export type ToolStatus = 1 | 2 | 4 | 5 | 6 | 8 | 9 | 10 | 11

export interface ToolRecord {
  id: string
  drawingNo: string
  serialNo: string
  warehouse: string
  shelf: string
  status: ToolStatus
  operator: string
  operatedAt: string
  isLatest: boolean
}

export interface CaseState {
  records: ToolRecord[]
  audit: string[]
}

export const statusNames: Record<ToolStatus, string> = {
  1: '在库',
  2: '返修出库',
  4: '定检出库',
  5: '使用',
  6: '外借',
  8: '报废',
  9: '转交',
  10: '配发',
  11: '外借待入库',
}

export const initialCaseState = (): CaseState => ({
  records: [
    {
      id: 'H-240903-01', drawingNo: 'GX-2024-017', serialNo: 'A-003', warehouse: '总装一库', shelf: 'A-07',
      status: 1, operator: '王工', operatedAt: '2026-09-03 09:18', isLatest: true,
    },
    {
      id: 'H-240828-03', drawingNo: 'GX-2024-011', serialNo: 'B-012', warehouse: '机加二库', shelf: 'C-12',
      status: 5, operator: '李工', operatedAt: '2026-08-28 15:42', isLatest: true,
    },
    {
      id: 'H-240821-02', drawingNo: 'GX-2024-008', serialNo: 'A-019', warehouse: '总装一库', shelf: 'B-02',
      status: 6, operator: '赵工', operatedAt: '2026-08-21 11:05', isLatest: true,
    },
  ],
  audit: ['演示数据已加载：3 条最新状态记录'],
})

export function applyDemoStep(state: CaseState, step: number): CaseState {
  const next = structuredClone(state)
  if (step === 1) {
    next.records.unshift({
      id: 'H-260908-01', drawingNo: 'GX-2026-042', serialNo: 'D-006', warehouse: '总装一库', shelf: 'D-06',
      status: 1, operator: '陈工', operatedAt: '2026-09-08 10:00', isLatest: true,
    })
    next.audit.unshift('10:00 · GX-2026-042 / D-006 完成入库，状态：在库')
    return next
  }

  if (step === 2) {
    const current = next.records.find((record) => record.drawingNo === 'GX-2026-042' && record.isLatest)
    if (!current || current.status !== 1) return next
    current.isLatest = false
    next.records.unshift({ ...current, id: 'H-260908-02', status: 6, operator: '周工', operatedAt: '2026-09-08 10:04', isLatest: true })
    next.audit.unshift('10:04 · 状态机校验通过：在库 → 外借；旧记录保留为历史版本')
    return next
  }

  if (step === 3) {
    next.audit.unshift('10:05 · 台账与操作明细已核对：最新状态唯一、历史链完整')
    return next
  }

  next.audit.unshift('10:06 · 形成运行证据：业务结果一致，审计轨迹可追溯')
  return next
}
